import { render, staticRenderFns } from "./SysCheckRuleTestModal.vue?vue&type=template&id=5389a22e&scoped=true"
import script from "./SysCheckRuleTestModal.vue?vue&type=script&lang=js"
export * from "./SysCheckRuleTestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5389a22e",
  null
  
)

export default component.exports